import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ReportDoctorWorkTime from 'app/containers/HumanResources/ReportDoctorWorkTime'

const ReportDoctorWorkTimePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_doctor_work_time)}</PageTitle>
      <ReportDoctorWorkTime />
    </>
  )
}
const ReportDoctorWorkTimePage = memo(ReportDoctorWorkTimePageCpn, isEqual)

export default ReportDoctorWorkTimePage
